// File: noviopus-ats-client/src/utils/form.ts
import toPath from 'lodash/toPath';
import get from 'lodash/get';
import pickBy from 'lodash/pickBy';
import { change as reduxChange } from 'redux-form';

export const getFieldId = (formName: string, fieldName: string) => `${formName}.${fieldName}`;

export const getFieldValue = (state: any) => (fieldId: string) => get(state, getFieldPath(fieldId));

const getFieldPath = (fieldId: string) => {
  const formName = getFormName(fieldId);
  const fieldName = getFieldName(fieldId);
  const fieldPath = ['form', formName, 'values', ...toPath(fieldName)];

  return fieldPath;
};

const getFormName = (fieldId: string) => fieldId.split('.')[0];
const getFieldName = (fieldId: string) => fieldId.split('.').slice(1).join('.');

export const getSiblingFieldId = (fieldId: string, fieldKey: string) => {
  const parts = fieldId.split('.').slice(0, -1);
  return parts.concat([fieldKey]).join('.');
};

export const change = (fieldId: string, value: any) => {
  return reduxChange(getFormName(fieldId), getFieldName(fieldId), value);
};

export const isCorrectNumberKey = (event: any): boolean =>
  event.ctrlKey ||
  event.altKey ||
  (47 < event.keyCode && event.keyCode < 58 && event.shiftKey == false) ||
  (95 < event.keyCode && event.keyCode < 106) ||
  event.keyCode == 8 ||
  event.keyCode == 9 ||
  (event.keyCode > 34 && event.keyCode < 40) ||
  event.keyCode == 46;

export const removeIndexedElement = (array: any[], i: number) => {
  if (!Array.isArray(array)) return [];
  return array.slice(0, i).concat(array.slice(i + 1, array.length));
};

export const isNumber = (value: string) => /^[0-9]+$|^$/.test(value) && value !== '0';

export const isLastField = (fieldName: string[], formValue: any) => {
  if (!formValue) return false;

  let field: any;

  // 1. Try ImmutableJS access (Legacy support)
  if (typeof formValue.getIn === 'function') {
    field = formValue.getIn(fieldName);
    if (field && typeof field.size === 'number') {
      return field.size > 1;
    }
    // If it was an immutable list converted to JS or just a value
    if (field && typeof field.toJS === 'function') {
        field = field.toJS();
    }
  } else {
    // 2. POJO access
    field = get(formValue, fieldName);
  }

  // 3. Array check
  if (Array.isArray(field) && field.length > 1) {
    return true;
  }
  
  return false;
};

export const isFormAction = (action: any) => action.type.indexOf('@@redux-form/') === 0;

export function filterChangedValues(values: any, initial: any) {
  return pickBy(values, (v, key) => v !== initial?.[key]);
}

export function numberFilter(newValue: string, initialValue: string) {
  if (newValue === '') return newValue;
  return newValue.search(/^\d+?\.??\d*?$/) !== -1 ? newValue : initialValue;
}

export function integerFilter(newValue: string, initialValue: string) {
  if (newValue === '') return newValue;
  return newValue.search(/\D/) === -1 ? newValue : initialValue;
}

export const sixDigitsMaxFilter = (newValue: string, initialValue: string) =>
  newValue.length > 6 ? initialValue : newValue;

export function notZeroFilter(newValue: string, initialValue: string) {
  return newValue.search(/[123456789]/) !== -1 ? newValue : '';
}

export function getImmutablePath(field: string) {
  return field
    .replace(/\[|\]/g, '.')
    .split('.')
    .filter((v) => !!v);
}

export function getMapDiff(map1: any, map2: any): any {
  return pickBy(map1, (v, k) => map2?.[k] !== v);
}

export const formatMultiSelectValue = (key: string, formValues: any) => {
  const value = get(formValues, key);
  
  if (!value) return [];
  
  // Handle Immutable List
  if (value && typeof value.toJS === 'function') {
      return value.toJS();
  }
  
  return Array.isArray(value) ? value : [];
};